import { toast } from "react-toastify";
import { instance } from "./api";
const url = process.env.REACT_APP_BASE_URL || "/";

async function getParticipantList(page, limit, filter, companyId,service) {
  // call the api for get participant list

  const api =
    url +
    `/companies/${companyId}/participants?page=${page}&filter=${encodeURIComponent(filter ?? "")}&limit=${limit}&service=${service}`;

  return await instance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function getParticipantDetails(companyId, participantId) {
  // call the api for get participant details

  const api =
    url + `/companies/${companyId}/participant/${participantId}/details`;

  return await instance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function editParticipantDetails(companyId, participantId, data) {
  // call the api for edit participant details

  const api = url + `/companies/${companyId}/participants/${participantId}`;

  return await instance
    .put(api, data)
    .then((response) => {
      //retun status 1 for success
      return 1;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function editParticipantDetailsSecretary(
  companyId,
  participantId,
  data
) {
  // call the api for edit participant details

  const api =
    url + `/companies/${companyId}/participants/${participantId}/sc`;

  return await instance
    .put(api, data)
    .then((response) => {
      //retun status 1 for success
      return 1;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function addParticipantDetails(companyId, workshopId, data) {
  // call the api for add participant details

  const api =
    url +
    `/companies/${companyId}/workshops/${workshopId}/participants/register`;

  return await instance
    .post(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function addIctParticipantDetails(companyId, workshopId, data) {
  // call the api for add participant details

  const api =
    url +
    `/ict/companies/${companyId}/workshops/${workshopId}/participants/register`;

  return await instance
    .post(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function DownloadParticipants(companyId, t, service) {
  // call the api for add participant details

  const api = url + `/companies/${companyId}/participants/download?service=${service}`;

  return await instance
    .get(api, {})
    .then((response) => {
      return response;
    })
    .catch((error) => {
      //show toast message
      if (error?.response?.data?.error?.error_code) {
        toast.error(t(error?.response?.data?.error?.error_code), {
          toastId: 3,
        });
      }
    });
}

const head={
  responseType: 'blob',
 }
async function DownloadBatchErrorList(companyId,errors, t) {
  // call the api for download 

  const api = url + `/companies/${companyId}/participants/batch-register/errors/download`;

  return await instance
    .post(api, errors, head)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      //show toast message
      if (error?.response?.data?.error?.error_code) {
        toast.error(t(error?.response?.data?.error?.error_code), {
          toastId: 3,
        });
      }
    });
}


async function ParticipantBatchImport(companyId, data) {
  // call the api for add participant details

  const api = url + `/companies/${companyId}/participants/batch-register`;

  return await instance
    .post(api,  {file:data},{headers:{'Content-Type':'multipart/form-data'}})
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function IctParticipantBatchImport(companyId, data) {
  // call the api for add ictparticipant details

  const api = url + `/ict/companies/${companyId}/participants/batch-register`;

  return await instance
    .post(api,  {file:data},{headers:{'Content-Type':'multipart/form-data'}})
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response?.data;
    });
}

async function IctDownloadBatchErrorList(companyId,errors, t) {
  // call the api for download 

  const api = url + `/ict/companies/${companyId}/participants/batch-register/errors/download`;

  return await instance
    .post(api, errors, head)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      //show toast message
      if (error?.response?.data?.error?.error_code) {
        toast.error(t(error?.response?.data?.error?.error_code), {
          toastId: 3,
        });
      }
    });
}

export const participantService = {
  DownloadBatchErrorList,
  ParticipantBatchImport,
  getParticipantList,
  getParticipantDetails,
  editParticipantDetails,
  editParticipantDetailsSecretary,
  addParticipantDetails,
  addIctParticipantDetails,
  DownloadParticipants,
  IctParticipantBatchImport,
  IctDownloadBatchErrorList
};
